import { Injectable } from '@angular/core';
import { ProposalService } from '../shared/proposal.service';
import { TrackService } from './track.service';

@Injectable({
    providedIn: 'root'
  })
  export class MapTrackingService {
  
    public _calculatedPremiums: any;
    get calculatedPremiums(): any {
        return this._calculatedPremiums;
      }
    form;
  
    
    constructor(public trackService: TrackService, private proposalService: ProposalService ) {}

    mapTrackPropertyCategories(value){
        var propertyCategories = [  
            {label: "Both: Building & content", value: "1"},
            {label: "Building only", value: "3"},
            {label: "Content only", value: "2"}
         ]
    
        let name = propertyCategories.find(x => x.value === value).label;
        this.trackService.addAttribute('propertyDetails.type',name)
    }

    mapTrackPropertySubCategories(value){
        var propertySubCategories = [ 
            {label: "House", value: "1", forId: "1"},
            {label: "Apartment", value: "2", forId: "1"},
            {label: "Content", value: "4", forId: "2"},
            {label: "House", value: "11", forId: "3"},
            {label: "Apartment", value: "12", forId: "3"}
         ]
     
         let name = propertySubCategories.find(x => x.value === value).label;
         this.trackService.addAttribute('propertyDetails.subType',name)
    }

    mapTrackPropertyPurpose(value){
        var propertySubCategories = [ 
            {label: "Primary residence", value: "1"},
            {label: "Holiday home ", value: "2"},
         ]
     
         let name = propertySubCategories.find(x => x.value === value).label;
         this.trackService.addAttribute('propertyDetails.purpose',name)
    }

    mapTrackPackages(value, installments, calculatedPremiums$, changed?){
        
        calculatedPremiums$.subscribe(data => {
            this.form=data;

            let packages = [ 
                {label: "COMFOR", value: "1", price: (installments == 2 || installments == 4) ? this.form.n_1NSP_Premium : this.form.topComfort},
                {label: "EXTRA", value: "2", price:  (installments == 2 || installments == 4) ? this.form.n_2NSP_Premium : this.form.topExtra},
                {label: "MAX", value: "3", price: (installments == 2 || installments == 4) ? this.form.n_3NSP_Premium : this.form.topMax,}
             ];

             if (changed==='packages'){
                let name = packages.find(x => x.value === value).label;
                this.trackService.pushEventTracking('product.name', name)
             }

             let price = packages.find(x => x.value === value).price;
             this.trackService.pushEventTracking('product.price', price)
          });
    }

  }